module.exports = __webpack_public_path__ + "img/instock.d4977bcd.svg";